/* PagingImagesFeed.js */

const PagingFeed = require("../../../../../../lib/PagingFeed");

class PagingImagesFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startRelatedLinksFeed({}, this._entityFields, this._sort, {
            skip: 0,
            limit: this._pageSize * 2,
        });
    }

    _feedReestablish() {
        return this._feed.reestablishFeed(this._activeOrgId, {}, this._entityFields, this._sort);
    }
}

module.exports = PagingImagesFeed;
